import { useAuth } from "contexts/useAuth";
import { ValidateUserPermissions } from "utils/validateUserPermissions";

type UseCanParams = {
    permissions?: string[];
}

export function useCan({ permissions }: UseCanParams) {

    const userHasValidPermissions = ValidateUserPermissions({ permissions })

    return userHasValidPermissions

}